import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { AdminDashboard } from '@/features/admin/components/AdminDashboard';

export const AdminPage = () => {
  const { isAdmin, isLoadingProfile } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoadingProfile && !isAdmin) {
      navigate('/', { replace: true });
    }
  }, [isAdmin, isLoadingProfile, navigate]);

  if (isLoadingProfile) {
    return (
      <div className="flex items-center justify-center min-h-screen text-slate-400 text-sm">
        Verifying permissions…
      </div>
    );
  }

  if (!isAdmin) {
    return null;
  }

  return <AdminDashboard />;
};
